<template>
  <div class="outterBox">
    <div class="container">
      <h2>SPECIAL OFFERS</h2>
      <SlideCarousels
        :item-total-count="items.length"
        :items="items"
        :breakpoints="breakpoints"
        :slide-number="3"
        :gap="3"
        :fixed-height="fixedHeight"
      >
        <template v-slot:slides>
          <VueperSlide lazy v-for="item in items" :key="item.id" :image="item.image">
            <template #content>
              <div class="top">
                <SpecialOffersItem :item="item" @ImgLoaded="refreshHeight" :boardId="boardId" />
              </div>
            </template>
          </VueperSlide>
        </template>
      </SlideCarousels>
    </div>
  </div>
</template>

<script>
import SlideCarousels from '@/components/SlideCarousels';
import {VueperSlide} from 'vueperslides';
import SpecialOffersItem from '@/pages/MainPage/Components/SpecialOffersItem';
import boardService from '@/services/board.service';
import {BOARD_ID} from '@/util/BoardConst';
import {BOARD_ID_PKG, BOARD_ID_PKG_NEW} from '@/pages/ReservePage/API/hotelBoardID';
import {BoardArticle} from '@/models';

export default {
  name: 'SpecialOffers',
  data() {
    return {
      fixedHeight: '547px',
      windowWidth: 0,
      items: [],
      boardId: BOARD_ID_PKG_NEW,
      breakpoints: {
        992: {
          bullets: false,
          arrows: false,
          visibleSlides: 2,
          touchable: false,
          disableArrowsOnEdges: true,
          fade: true,
          animation: false,
        },

        500: {
          bullets: false,
          arrows: false,
          visibleSlides: 1,
          touchable: false,
          disableArrowsOnEdges: true,
          fade: true,
          animation: false,
        },
      },
    };
  },
  components: {
    SlideCarousels,
    VueperSlide,
    SpecialOffersItem,
  },

  async created() {
    // {
    //   id: 0,
    //   pkgName: '포도호텔 PACKAGE',
    //   title: '[2박전용] New Premium 패키지[2박전용] New Premium 패키지[2박전용] New Premium 패키지[2박전용] New Premium 패키지',
    //   startDate: '2021.10.01',
    //   endDate: '2021.12.31',
    //   desc: '골프, 호텔, 식사까지 핀크스  경험해 보시기 바랍니다.',
    //   image: 'special_offers_sample01.jpg',
    // },

    // const aList = await boardService.getArticleList(
    //   BOARD_ID.BID_PODO_SPECIAL_OFFER,
    //   1,
    //   10,
    //   'BoardArticleDetailWithFiles',
    // );

    // console.log(aList);

    // this.items = aList._embedded.boardArticles.map(x => ({
    //   id: x.id,
    //   pkgName: x.subtitle1,
    //   title: x.title,
    //   startDate: x.startDate.split('T')[0],
    //   endDate: x.endDate.split('T')[0],
    //   desc: x.subtitle2,
    //   image: `${x.attachFiles[0]?.urlPath}${x.attachFiles[0]?.fileName}`,
    // }));
    //

    let detailItems = (
      await boardService.getArticleListWithMemo(
        BOARD_ID_PKG_NEW,
        1,
        100,
        'BoardArticleDetailWithMemoWithoutBase64',
        'id',
        'desc',
        true,
      )
    )._embedded.boardArticles.map(x => new BoardArticle(x));

    // 패키지별 대표 이미지 조회는 병렬로 수행
    await Promise.all(
      detailItems.map(async detailItem => {
        const data = JSON.parse(detailItem.memo);
        if (data.thumbPic1 && data.thumbPic1 !== '') {
          detailItem.thumbnailUrl = data.thumbPic1;
        }

        let pkgitems = (
          await boardService.getArticleList(
            BOARD_ID_PKG,
            1,
            100,
            'BoardArticleDetailWithFilesWithoutBase64',
            'sortIdx',
            'desc',
            true,
            detailItem.subtitle1,
          )
        )._embedded.boardArticles.map(x => new BoardArticle(x));

        if (pkgitems.length > 0) {
          detailItem.attachFiles[0] = pkgitems[0].attachFiles[0];
        }
      }),
    );
    this.items = detailItems;
    console.log('SPECIAL OFFERS', this.items);
    window.addEventListener('resize', this.onResize);
  },
  watch: {
    windowWidth(newHeight, oldHeight) {
      this.refreshHeight();
    },
  },
  mounted() {
    this.refreshHeight();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },

  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    refreshHeight() {
      this.$nextTick(() => {
        console.log('HEIGHT>>>!!!0', this.$refs.top);
        if (this.$refs.top !== undefined) {
          let px = this.$refs.top[0].clientHeight;
          this.fixedHeight = `${px + 20}px`;
          console.log('HEIGHT>>>!!!0', this.fixedHeight);
        }
      });
    },
  },
};
</script>

<style></style>

<style scoped lang="scss">
h2 {
  padding-top: 3rem;
  padding-bottom: 3rem;
  height: 8rem;
  text-align: center;
  color: #222222;
  font-family: 'Jeju Myeongjo', sans-serif;
  font-weight: 700;
}

.outterBox {
  border-top: 1px solid #eaeaea;
}
</style>
